export const STATUS_COLORS: Record<string, 'success' | 'warning' | 'error' | 'info' | 'default'> = {
  completed: 'success',
  running: 'info',
  pending: 'warning',
  failed: 'error',
}
